export default "__VITE_ASSET__IRM2dR9g__"